import { render, staticRenderFns } from "./category-levels-assessment-desktop.vue?vue&type=template&id=58640615&"
import script from "./category-levels-assessment-desktop.vue?vue&type=script&lang=ts&"
export * from "./category-levels-assessment-desktop.vue?vue&type=script&lang=ts&"
import style0 from "./category-levels-assessment-desktop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports